import Clients from "./Clients.vue";

export default Clients;
